module.exports = __webpack_public_path__ + "static/media/tabs.9e58bb3d.css";